import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Person} from 'src/app/shared/models/person.models';
import {PaymentDetailsService} from 'src/app/shared/services/member-details.service';
import {LogService} from '../../shared/services/log.services';

declare global {
  interface Window { logError: any; logInfo: any; }
}

@Component({
  selector: 'ben-chatbot',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatBotComponent implements OnInit, AfterViewInit {
  dataSet: boolean = false;
  constructor(private memberDetailsService: PaymentDetailsService,
              private logService: LogService) {
    var self = this;
  }

  ngOnInit(): void {
    this.importExternalScript();
  }

  ngAfterViewInit(): void {
    this.loadUserDetais();
  }

  importExternalScript() {
    if (document.getElementById("sabio-chat") == null) {
      let node = document.createElement('script');
      node.src = "../../../assets/Resources/scripts/sabio-chat.js";
      node.type = 'text/javascript';
      node.async = true;
      node.charset = 'utf-8';
      node.id = "sabio-chat";
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  private loadUserDetais() {
    this.memberDetailsService.GetChatUserDetails().subscribe(data => {
      this.loadUserDataToChat(data);
    });
  }

  private loadUserDataToChat(data: Person) {
    var self = this;
    if ((window as any).Genesys != undefined) {
      var genesys = (window as any).Genesys;
      var messaging = {
        customAttributes: {
          memberId: data.Id,
          title: data.Title,
          surname: data.Surname,
          forename: data.Forename
        }
      };

      //Database.ready only fires once per page load
      genesys('subscribe', 'Database.ready', function () {
        self.logService.info("Subscribing to Database.ready..");
        if (!self.dataSet) {
          self.logService.info("Subscribing to Database.ready..");
          genesys("command", "Database.set", { messaging: messaging },
            function () {
              self.dataSet = true;
              self.logService.info("Member data loaded - setting values to database");
            },
            function (er: any) { self.logService.error(er); });
        }
      });

      genesys('subscribe', 'Messenger.opened', function () {
        self.logService.info("Subscribing to Messenger.opened..");
        genesys("command", "Database.update", {messaging: messaging},
          function () {
            self.logService.info("Updating values in database");
          },
          function (er: any) {
            self.logService.error(er);
          });
      });

      genesys('subscribe', 'Messenger.closed', function () {
        self.logService.info("Clearing database on Messenger closed.");
        genesys("command", "Database.update",  {messaging: { customAttributes: null }});
      });

    } else {
      setTimeout(() => {
        this.loadUserDataToChat(data);
      }, 100);
    }
  }
}
